import React from 'react';  
import './index.css';
import { Badge,WingBlank, WhiteSpace, SegmentedControl } from 'antd-mobile';
 
 import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'labroomVideoStore';
import Bottom  from '../interlocutionBottom';
import moment from "moment"; 
const navList=['我的问答', '同学们的问答']
class Avatar extends React.Component{
  render(){
    const{data}=this.props;
    const  time = data.addtime;
    const  addtime = moment(time*1000).format('YYYY-MM-DD HH:mm:ss'); 
    return(
      <div className="user-wrapper">
        <span className="user-avatar" style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>U</span>
        <div className="user-info">
        <span className="user-name">{data.username}</span>
        <span className="user-time"> {addtime}</span>
        </div>
      </div> 
      )
  }
}
class InterAnswer extends React.Component{
  render(){
    const{data}=this.props
    return(
        <div className="answer-wrapper">
          <Badge className="answer-badge" text="答" />
          <div className="answer-text">
            <span className="answer-name">{data.username}：</span>
            <span>{data.content}</span>
          </div>
        </div>
      )
  }
}

class InterMain extends React.Component{
  render(){
    const{data}=this.props;
    return(
      <div className="inter-main-wrapper">
        <WhiteSpace/>
        <div className="ask-wrapper">
          <Badge className="ask-badge" text="问" />
          <div className="answer-box">
            <span >{data.question?data.question:''}</span>
          </div>
        </div>
        <WhiteSpace/>
        {
          data.answer?
          <InterAnswer data={data.answer}/> 
          :null
        }
      </div> 
      )
  }
}
class InterItem extends React.Component{
  render(){
    return(
      <div className="inter-item">
        <Avatar data={this.props.data}/> 
        <InterMain  data={this.props.data}/>
      </div>)
  }
}

class TabInter extends React.Component{
  constructor(props){
    super(props)
    this.state={
      otherQuestionList:[],
      userQuestionList:[],
      questionList:[],
      currentIndex: 0
    }
  }
 
    sestCurrentStyle = (index) => {
        return this.state.currentIndex === index ? 'current' : ''
    }
    handleClick = (e) => {
        const nodeName = e.target.nodeName.toUpperCase()
        let tag = e.target;
        if (nodeName === 'LI') {
            let index = parseInt(tag.getAttribute('index'))
            this.setState({
                currentIndex: index
            })
             this.onValueChange(index)
        }
       
    }
  componentDidMount() {  
      setTimeout(() => { 
        this.setState({
          questionList:this.props.userQuestionList
        }) 
      }, 600);
     
  }
  componentWillReceiveProps(nextProps) {  

    if(nextProps.otherQuestionList.toJS()!==this.props.otherQuestionList.toJS()){
      setTimeout(() => {  
        this.setState({
           otherQuestionList:nextProps.otherQuestionList,
           questionList:nextProps.otherQuestionList,
        }); 
      }, 600);
    }
    if (nextProps.userQuestionList.toJS() !== this.props.userQuestionList.toJS()) {
      setTimeout(() => {  
        this.setState({
           userQuestionList:nextProps.userQuestionList,
           questionList:nextProps.userQuestionList,
        }); 
      }, 600);
    }
  }
  addQuestion(data){
    const {addQuestion,course_id} =this.props;
    addQuestion(data,course_id);
  
  }
 
  onValueChange = (value) => {
    const {userQuestionList,otherQuestionList} =this.props;
    if(value===1){
      this.setState({
          questionList:otherQuestionList
      }) 
    }else {
      this.setState({
          questionList:userQuestionList
      })
    }
  }
  render(){
    const {questionList} =this.state;
    return (
      <div className="tab-inter">
        <WingBlank>
          <div className="inter-wrapper">
          <WhiteSpace/>
            <div className="inter-segmentedControl"> 
              <WhiteSpace/>
             <div className='nav-wrap inter-control' onClick={(e)=>this.handleClick(e)}>
                {
                    navList && navList.map( (item, index) => {
                        return (
                            <li key={index} index={index} className={this.state.currentIndex === index ? 'active' : ''}>{item}</li>
                        )
                    })
                }
            </div>
             {/* <SegmentedControl
                  values={['我的问答', '同学们的问答']} 
                  onValueChange={this.onValueChange}
                  tintColor={'#fff'}
                  style={{height:'45px'}}
                />
             */}
              <WhiteSpace/>
            </div>
            {
              questionList&&questionList.size!=0?
              questionList.map((item,index)=>{
                return (<InterItem key={index} data={item.toJS()}/> )
              }):
              <p style={{textAlign:'center'}}>暂无</p>
            }
          </div>
        </WingBlank>
         <Bottom  
            sendData={(data)=>{this.addQuestion(data)}}
            />
      </div>
      )
  }
}
 
const mapState = (state) => ({ 
  userQuestionList: state.getIn(['labroomvideo', 'userQuestionList']),
  otherQuestionList: state.getIn(['labroomvideo', 'otherQuestionList']),
  course_id: state.getIn(['labroomvideo', 'subjectInfo','course_id']),
})
const mapDispatch = (dispatch) => ({
  addQuestion(content,course_id){
    dispatch(actionCreators.addQuestion(content,course_id))
  },
  getUserQuestionList(course_id,user_id){
    dispatch(actionCreators.getUserQuestionList(course_id,user_id))
  },
  getOthersQuestionList(course_id,user_id){
    dispatch(actionCreators.getOthersQuestionList(course_id,user_id))
  }
   
})
export default connect(mapState, mapDispatch)(TabInter);